import { unref as f, computed as B, onMounted as ft, provide as vt, isRef as Te, watch as K, getCurrentInstance as ke, onBeforeUnmount as mt, defineComponent as Re, toRef as ue, resolveDynamicComponent as qe, h as Be, ref as Y, reactive as Je, nextTick as me, warn as yt, watchEffect as Pt, inject as gt, onUnmounted as ht, markRaw as Rt } from "vue";
function Dt() {
  return bt().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function bt() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Ut = typeof Proxy == "function", Lt = "devtools-plugin:setup", $t = "plugin:settings:set";
let ve, He;
function zt() {
  var e;
  return ve !== void 0 || (typeof window < "u" && window.performance ? (ve = !0, He = window.performance) : typeof global < "u" && (!((e = global.perf_hooks) === null || e === void 0) && e.performance) ? (ve = !0, He = global.perf_hooks.performance) : ve = !1), ve;
}
function Gt() {
  return zt() ? He.now() : Date.now();
}
class xt {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const l in t.settings) {
        const s = t.settings[l];
        r[l] = s.defaultValue;
      }
    const a = `__vue-devtools-plugin-settings__${t.id}`;
    let i = Object.assign({}, r);
    try {
      const l = localStorage.getItem(a), s = JSON.parse(l);
      Object.assign(i, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(l) {
        try {
          localStorage.setItem(a, JSON.stringify(l));
        } catch {
        }
        i = l;
      },
      now() {
        return Gt();
      }
    }, n && n.on($t, (l, s) => {
      l === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (l, s) => this.target ? this.target.on[s] : (...d) => {
        this.onQueue.push({
          method: s,
          args: d
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (l, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...d) => (this.targetQueue.push({
        method: s,
        args: d,
        resolve: () => {
        }
      }), this.fallbacks[s](...d)) : (...d) => new Promise((c) => {
        this.targetQueue.push({
          method: s,
          args: d,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function Ht(e, t) {
  const n = e, r = bt(), a = Dt(), i = Ut && n.enableEarlyProxy;
  if (a && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !i))
    a.emit(Lt, e, t);
  else {
    const l = i ? new xt(n, a) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: l
    }), l && t(l.proxiedTarget);
  }
}
/**
  * vee-validate v4.7.3
  * (c) 2022 Abdelrahman Awad
  * @license MIT
  */
function ge(e) {
  return typeof e == "function";
}
function Fe(e) {
  return e == null;
}
const se = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function pt(e) {
  return Number(e) >= 0;
}
function Wt(e) {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}
const Kt = {};
function Qt(e) {
  return Kt[e];
}
const pe = Symbol("vee-validate-form"), qt = Symbol("vee-validate-field-instance"), Pe = Symbol("Default empty value"), Jt = typeof window < "u";
function We(e) {
  return ge(e) && !!e.__locatorRef;
}
function we(e) {
  return !!e && ge(e.validate);
}
function he(e) {
  return e === "checkbox" || e === "radio";
}
function Yt(e) {
  return se(e) || Array.isArray(e);
}
function Vt(e) {
  return Array.isArray(e) ? e.length === 0 : se(e) && Object.keys(e).length === 0;
}
function De(e) {
  return /^\[.+\]$/i.test(e);
}
function Xt(e) {
  return Ot(e) && e.multiple;
}
function Ot(e) {
  return e.tagName === "SELECT";
}
function Zt(e, t) {
  const n = ![!1, null, void 0, 0].includes(t.multiple) && !Number.isNaN(t.multiple);
  return e === "select" && "multiple" in t && n;
}
function en(e, t) {
  return !Zt(e, t) && t.type !== "file" && !he(t.type);
}
function At(e) {
  return Ye(e) && e.target && "submit" in e.target;
}
function Ye(e) {
  return e ? !!(typeof Event < "u" && ge(Event) && e instanceof Event || e && e.srcElement) : !1;
}
function it(e, t) {
  return t in e && e[t] !== Pe;
}
function P(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!P(e[r], t[r]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      for (r of e.entries())
        if (!P(r[1], t.get(r[0])))
          return !1;
      return !0;
    }
    if (at(e) && at(t))
      return !(e.size !== t.size || e.name !== t.name || e.lastModified !== t.lastModified || e.type !== t.type);
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      var i = a[r];
      if (!P(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function at(e) {
  return Jt ? e instanceof File : !1;
}
function lt(e, t, n) {
  typeof n.value == "object" && (n.value = j(n.value)), !n.enumerable || n.get || n.set || !n.configurable || !n.writable || t === "__proto__" ? Object.defineProperty(e, t, n) : e[t] = n.value;
}
function j(e) {
  if (typeof e != "object")
    return e;
  var t = 0, n, r, a, i = Object.prototype.toString.call(e);
  if (i === "[object Object]" ? a = Object.create(e.__proto__ || null) : i === "[object Array]" ? a = Array(e.length) : i === "[object Set]" ? (a = /* @__PURE__ */ new Set(), e.forEach(function(l) {
    a.add(j(l));
  })) : i === "[object Map]" ? (a = /* @__PURE__ */ new Map(), e.forEach(function(l, s) {
    a.set(j(s), j(l));
  })) : i === "[object Date]" ? a = /* @__PURE__ */ new Date(+e) : i === "[object RegExp]" ? a = new RegExp(e.source, e.flags) : i === "[object DataView]" ? a = new e.constructor(j(e.buffer)) : i === "[object ArrayBuffer]" ? a = e.slice(0) : i.slice(-6) === "Array]" && (a = new e.constructor(e)), a) {
    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      lt(a, r[t], Object.getOwnPropertyDescriptor(e, r[t]));
    for (t = 0, r = Object.getOwnPropertyNames(e); t < r.length; t++)
      Object.hasOwnProperty.call(a, n = r[t]) && a[n] === e[n] || lt(a, n, Object.getOwnPropertyDescriptor(e, n));
  }
  return a || e;
}
function Xe(e) {
  return De(e) ? e.replace(/\[|\]/gi, "") : e;
}
function M(e, t, n) {
  return e ? De(t) ? e[Xe(t)] : (t || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((a, i) => Yt(a) && i in a ? a[i] : n, e) : n;
}
function ae(e, t, n) {
  if (De(t)) {
    e[Xe(t)] = n;
    return;
  }
  const r = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let a = e;
  for (let i = 0; i < r.length; i++) {
    if (i === r.length - 1) {
      a[r[i]] = n;
      return;
    }
    (!(r[i] in a) || Fe(a[r[i]])) && (a[r[i]] = pt(r[i + 1]) ? [] : {}), a = a[r[i]];
  }
}
function Ge(e, t) {
  if (Array.isArray(e) && pt(t)) {
    e.splice(Number(t), 1);
    return;
  }
  se(e) && delete e[t];
}
function Ne(e, t) {
  if (De(t)) {
    delete e[Xe(t)];
    return;
  }
  const n = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = e;
  for (let i = 0; i < n.length; i++) {
    if (i === n.length - 1) {
      Ge(r, n[i]);
      break;
    }
    if (!(n[i] in r) || Fe(r[n[i]]))
      break;
    r = r[n[i]];
  }
  const a = n.map((i, l) => M(e, n.slice(0, l).join(".")));
  for (let i = a.length - 1; i >= 0; i--)
    if (Vt(a[i])) {
      if (i === 0) {
        Ge(e, n[0]);
        continue;
      }
      Ge(a[i - 1], n[i - 1]);
    }
}
function T(e) {
  return Object.keys(e);
}
function Ue(e, t = void 0) {
  const n = ke();
  return (n == null ? void 0 : n.provides[e]) || gt(e, t);
}
function Me(e) {
  yt(`[vee-validate]: ${e}`);
}
function tn(e) {
  return Array.isArray(e) ? e[0] : e;
}
function Ke(e, t, n) {
  if (Array.isArray(e)) {
    const r = [...e], a = r.findIndex((i) => P(i, t));
    return a >= 0 ? r.splice(a, 1) : r.push(t), r;
  }
  return P(e, t) ? n : t;
}
function nn(e, t) {
  let n, r;
  return function(...a) {
    const i = this;
    return n || (n = !0, setTimeout(() => n = !1, t), r = e.apply(i, a)), r;
  };
}
function ut(e, t = 0) {
  let n = null, r = [];
  return function(...a) {
    return n && window.clearTimeout(n), n = window.setTimeout(() => {
      const i = e(...a);
      r.forEach((l) => l(i)), r = [];
    }, t), new Promise((i) => r.push(i));
  };
}
function rn(e, t) {
  return se(t) && t.number ? Wt(e) : e;
}
function Qe(e, t) {
  let n;
  return async function(...a) {
    const i = e(...a);
    n = i;
    const l = await i;
    return i !== n || (n = void 0, t(l, a)), l;
  };
}
function an({ get: e, set: t }) {
  const n = Y(j(e()));
  return K(e, (r) => {
    P(r, n.value) || (n.value = j(r));
  }, {
    deep: !0
  }), K(n, (r) => {
    P(r, e()) || t(j(r));
  }, {
    deep: !0
  }), n;
}
const Le = (e, t, n) => t.slots.default ? typeof e == "string" || !e ? t.slots.default(n()) : {
  default: () => {
    var r, a;
    return (a = (r = t.slots).default) === null || a === void 0 ? void 0 : a.call(r, n());
  }
} : t.slots.default;
function xe(e) {
  if (St(e))
    return e._value;
}
function St(e) {
  return "_value" in e;
}
function Ze(e) {
  if (!Ye(e))
    return e;
  const t = e.target;
  if (he(t.type) && St(t))
    return xe(t);
  if (t.type === "file" && t.files) {
    const n = Array.from(t.files);
    return t.multiple ? n : n[0];
  }
  if (Xt(t))
    return Array.from(t.options).filter((n) => n.selected && !n.disabled).map(xe);
  if (Ot(t)) {
    const n = Array.from(t.options).find((r) => r.selected);
    return n ? xe(n) : t.value;
  }
  return t.value;
}
function Ft(e) {
  const t = {};
  return Object.defineProperty(t, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), e ? se(e) && e._$$isNormalized ? e : se(e) ? Object.keys(e).reduce((n, r) => {
    const a = ln(e[r]);
    return e[r] !== !1 && (n[r] = ot(a)), n;
  }, t) : typeof e != "string" ? t : e.split("|").reduce((n, r) => {
    const a = un(r);
    return a.name && (n[a.name] = ot(a.params)), n;
  }, t) : t;
}
function ln(e) {
  return e === !0 ? [] : Array.isArray(e) || se(e) ? e : [e];
}
function ot(e) {
  const t = (n) => typeof n == "string" && n[0] === "@" ? on(n.slice(1)) : n;
  return Array.isArray(e) ? e.map(t) : e instanceof RegExp ? [e] : Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {});
}
const un = (e) => {
  let t = [];
  const n = e.split(":")[0];
  return e.includes(":") && (t = e.split(":").slice(1).join(":").split(",")), { name: n, params: t };
};
function on(e) {
  const t = (n) => M(n, e) || n[e];
  return t.__locatorRef = e, t;
}
function sn(e) {
  return Array.isArray(e) ? e.filter(We) : T(e).filter((t) => We(e[t])).map((t) => e[t]);
}
const cn = {
  generateMessage: ({ field: e }) => `${e} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let dn = Object.assign({}, cn);
const et = () => dn;
async function wt(e, t, n = {}) {
  const r = n == null ? void 0 : n.bails, a = {
    name: (n == null ? void 0 : n.name) || "{field}",
    rules: t,
    bails: r ?? !0,
    formData: (n == null ? void 0 : n.values) || {}
  }, l = (await fn(a, e)).errors;
  return {
    errors: l,
    valid: !l.length
  };
}
async function fn(e, t) {
  if (we(e.rules))
    return vn(t, e.rules, { bails: e.bails });
  if (ge(e.rules) || Array.isArray(e.rules)) {
    const l = {
      field: e.name,
      form: e.formData,
      value: t
    }, s = Array.isArray(e.rules) ? e.rules : [e.rules], d = s.length, c = [];
    for (let O = 0; O < d; O++) {
      const b = s[O], A = await b(t, l);
      if (typeof A != "string" && A)
        continue;
      const R = typeof A == "string" ? A : _t(l);
      if (c.push(R), e.bails)
        return {
          errors: c
        };
    }
    return {
      errors: c
    };
  }
  const n = Object.assign(Object.assign({}, e), { rules: Ft(e.rules) }), r = [], a = Object.keys(n.rules), i = a.length;
  for (let l = 0; l < i; l++) {
    const s = a[l], d = await mn(n, t, {
      name: s,
      params: n.rules[s]
    });
    if (d.error && (r.push(d.error), e.bails))
      return {
        errors: r
      };
  }
  return {
    errors: r
  };
}
async function vn(e, t, n) {
  var r;
  return {
    errors: await t.validate(e, {
      abortEarly: (r = n.bails) !== null && r !== void 0 ? r : !0
    }).then(() => []).catch((i) => {
      if (i.name === "ValidationError")
        return i.errors;
      throw i;
    })
  };
}
async function mn(e, t, n) {
  const r = Qt(n.name);
  if (!r)
    throw new Error(`No such validator '${n.name}' exists.`);
  const a = yn(n.params, e.formData), i = {
    field: e.name,
    value: t,
    form: e.formData,
    rule: Object.assign(Object.assign({}, n), { params: a })
  }, l = await r(t, a, i);
  return typeof l == "string" ? {
    error: l
  } : {
    error: l ? void 0 : _t(i)
  };
}
function _t(e) {
  const t = et().generateMessage;
  return t ? t(e) : "Field is invalid";
}
function yn(e, t) {
  const n = (r) => We(r) ? r(t) : r;
  return Array.isArray(e) ? e.map(n) : Object.keys(e).reduce((r, a) => (r[a] = n(e[a]), r), {});
}
async function gn(e, t) {
  const n = await e.validate(t, { abortEarly: !1 }).then(() => []).catch((i) => {
    if (i.name !== "ValidationError")
      throw i;
    return i.inner || [];
  }), r = {}, a = {};
  for (const i of n) {
    const l = i.errors;
    r[i.path] = { valid: !l.length, errors: l }, l.length && (a[i.path] = l[0]);
  }
  return {
    valid: !n.length,
    results: r,
    errors: a
  };
}
async function hn(e, t, n) {
  const a = T(e).map(async (c) => {
    var O, b, A;
    const C = await wt(M(t, c), e[c], {
      name: ((O = n == null ? void 0 : n.names) === null || O === void 0 ? void 0 : O[c]) || c,
      values: t,
      bails: (A = (b = n == null ? void 0 : n.bailsMap) === null || b === void 0 ? void 0 : b[c]) !== null && A !== void 0 ? A : !0
    });
    return Object.assign(Object.assign({}, C), { path: c });
  });
  let i = !0;
  const l = await Promise.all(a), s = {}, d = {};
  for (const c of l)
    s[c.path] = {
      valid: c.valid,
      errors: c.errors
    }, c.valid || (i = !1, d[c.path] = c.errors[0]);
  return {
    valid: i,
    results: s,
    errors: d
  };
}
let st = 0;
function bn(e, t) {
  const { value: n, initialValue: r, setInitialValue: a } = Et(e, t.modelValue, t.form), { errorMessage: i, errors: l, setErrors: s } = Vn(e, t.form), d = pn(n, r, l), c = st >= Number.MAX_SAFE_INTEGER ? 0 : ++st;
  function O(b) {
    var A;
    "value" in b && (n.value = b.value), "errors" in b && s(b.errors), "touched" in b && (d.touched = (A = b.touched) !== null && A !== void 0 ? A : d.touched), "initialValue" in b && a(b.initialValue);
  }
  return {
    id: c,
    path: e,
    value: n,
    initialValue: r,
    meta: d,
    errors: l,
    errorMessage: i,
    setState: O
  };
}
function Et(e, t, n) {
  const r = Y(f(t));
  function a() {
    return n ? M(n.meta.value.initialValues, f(e), f(r)) : f(r);
  }
  function i(c) {
    if (!n) {
      r.value = c;
      return;
    }
    n.stageInitialValue(f(e), c, !0);
  }
  const l = B(a);
  if (!n)
    return {
      value: Y(a()),
      initialValue: l,
      setInitialValue: i
    };
  const s = t ? f(t) : M(n.values, f(e), f(l));
  return n.stageInitialValue(f(e), s, !0), {
    value: B({
      get() {
        return M(n.values, f(e));
      },
      set(c) {
        n.setFieldValue(f(e), c);
      }
    }),
    initialValue: l,
    setInitialValue: i
  };
}
function pn(e, t, n) {
  const r = Je({
    touched: !1,
    pending: !1,
    valid: !0,
    validated: !!f(n).length,
    initialValue: B(() => f(t)),
    dirty: B(() => !P(f(e), f(t)))
  });
  return K(n, (a) => {
    r.valid = !a.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), r;
}
function Vn(e, t) {
  function n(a) {
    return a ? Array.isArray(a) ? a : [a] : [];
  }
  if (!t) {
    const a = Y([]);
    return {
      errors: a,
      errorMessage: B(() => a.value[0]),
      setErrors: (i) => {
        a.value = n(i);
      }
    };
  }
  const r = B(() => t.errorBag.value[f(e)] || []);
  return {
    errors: r,
    errorMessage: B(() => r.value[0]),
    setErrors: (a) => {
      t.setFieldErrorBag(f(e), n(a));
    }
  };
}
function kt(e) {
  process.env.NODE_ENV !== "production" && Ht({
    id: "vee-validate-devtools-plugin",
    label: "VeeValidate Plugin",
    packageName: "vee-validate",
    homepage: "https://vee-validate.logaretm.com/v4",
    app: e,
    logo: "https://vee-validate.logaretm.com/v4/logo.png"
  }, Sn);
}
const _e = {}, Ee = {};
let le;
const be = nn(() => {
  setTimeout(async () => {
    await me(), le == null || le.sendInspectorState(ye), le == null || le.sendInspectorTree(ye);
  }, 100);
}, 100);
function On(e) {
  const t = ke();
  if (!le) {
    const n = t == null ? void 0 : t.appContext.app;
    if (!n)
      return;
    kt(n);
  }
  _e[e.formId] = Object.assign({}, e), _e[e.formId]._vm = t, ht(() => {
    delete _e[e.formId], be();
  }), be();
}
function An(e) {
  const t = ke();
  if (!le) {
    const n = t == null ? void 0 : t.appContext.app;
    if (!n)
      return;
    kt(n);
  }
  Ee[e.id] = Object.assign({}, e), Ee[e.id]._vm = t, ht(() => {
    delete Ee[e.id], be();
  }), be();
}
const ye = "vee-validate-inspector", W = {
  error: 12405579,
  success: 448379,
  unknown: 5522283,
  white: 16777215,
  black: 0,
  blue: 218007,
  purple: 12157168,
  orange: 16099682,
  gray: 12304330
};
let ie = null;
function Sn(e) {
  le = e, e.addInspector({
    id: ye,
    icon: "rule",
    label: "vee-validate",
    noSelectionText: "Select a vee-validate node to inspect",
    actions: [
      {
        icon: "done_outline",
        tooltip: "Validate selected item",
        action: async () => {
          if (!ie) {
            console.error("There is not a valid selected vee-validate node or component");
            return;
          }
          const t = await ie.validate();
          console.log(t);
        }
      },
      {
        icon: "delete_sweep",
        tooltip: "Clear validation state of the selected item",
        action: () => {
          if (!ie) {
            console.error("There is not a valid selected vee-validate node or component");
            return;
          }
          if ("id" in ie) {
            ie.resetField();
            return;
          }
          ie.resetForm();
        }
      }
    ]
  }), e.on.getInspectorTree((t) => {
    if (t.inspectorId !== ye)
      return;
    const n = Object.values(_e), r = Object.values(Ee);
    t.rootNodes = [
      ...n.map(Fn),
      ...r.map((a) => tt(a))
    ];
  }), e.on.getInspectorState((t, n) => {
    if (t.inspectorId !== ye || n.currentTab !== `custom-inspector:${ye}`)
      return;
    const { form: r, field: a, type: i } = wn(t.nodeId);
    if (r && i === "form") {
      t.state = En(r), ie = r;
      return;
    }
    if (a && i === "field") {
      t.state = _n(a), ie = a;
      return;
    }
    ie = null;
  });
}
function Fn(e) {
  const { textColor: t, bgColor: n } = jt(e), r = {};
  Object.values(e.fieldsByPath.value).forEach((l) => {
    const s = Array.isArray(l) ? l[0] : l;
    s && ae(r, f(s.name), tt(s, e));
  });
  function a(l, s = []) {
    const d = [...s].pop();
    return "id" in l ? Object.assign(Object.assign({}, l), { label: d || l.label }) : se(l) ? {
      id: `${s.join(".")}`,
      label: d || "",
      children: Object.keys(l).map((c) => a(l[c], [...s, c]))
    } : Array.isArray(l) ? {
      id: `${s.join(".")}`,
      label: `${d}[]`,
      children: l.map((c, O) => a(c, [...s, String(O)]))
    } : { id: "", label: "", children: [] };
  }
  const { children: i } = a(r);
  return {
    id: It(e),
    label: "Form",
    children: i,
    tags: [
      {
        label: "Form",
        textColor: t,
        backgroundColor: n
      },
      {
        label: `${Object.keys(e.fieldsByPath.value).length} fields`,
        textColor: W.white,
        backgroundColor: W.unknown
      }
    ]
  };
}
function tt(e, t) {
  const n = tn(e), { textColor: r, bgColor: a } = jt(n), i = Array.isArray(e) && e.length > 1;
  return {
    id: It(t, n, !i),
    label: f(n.name),
    children: Array.isArray(e) ? e.map((l) => tt(l, t)) : void 0,
    tags: [
      i ? void 0 : {
        label: "Field",
        textColor: r,
        backgroundColor: a
      },
      t ? void 0 : {
        label: "Standalone",
        textColor: W.black,
        backgroundColor: W.gray
      },
      !i && n.type === "checkbox" ? {
        label: "Checkbox",
        textColor: W.white,
        backgroundColor: W.blue
      } : void 0,
      !i && n.type === "radio" ? {
        label: "Radio",
        textColor: W.white,
        backgroundColor: W.purple
      } : void 0,
      i ? {
        label: "Group",
        textColor: W.black,
        backgroundColor: W.orange
      } : void 0
    ].filter(Boolean)
  };
}
function It(e, t, n = !0) {
  const r = e ? f(t == null ? void 0 : t.name) : t == null ? void 0 : t.id, a = r ? e == null ? void 0 : e.fieldsByPath.value[r] : void 0;
  let i;
  n && t && Array.isArray(a) && (i = a.indexOf(t));
  const l = { f: e == null ? void 0 : e.formId, ff: r, idx: i, type: t ? "field" : "form" };
  return btoa(JSON.stringify(l));
}
function wn(e) {
  try {
    const t = JSON.parse(atob(e)), n = _e[t.f];
    if (!n && t.ff) {
      const a = Ee[t.ff];
      return a ? {
        type: t.type,
        field: a
      } : {};
    }
    if (!n)
      return {};
    const r = n.fieldsByPath.value[t.ff];
    return {
      type: t.type,
      form: n,
      field: Array.isArray(r) ? r[t.idx || 0] : r
    };
  } catch {
  }
  return {};
}
function _n(e) {
  const { errors: t, meta: n, value: r } = e;
  return {
    "Field state": [
      { key: "errors", value: t.value },
      {
        key: "initialValue",
        value: n.initialValue
      },
      {
        key: "currentValue",
        value: r.value
      },
      {
        key: "touched",
        value: n.touched
      },
      {
        key: "dirty",
        value: n.dirty
      },
      {
        key: "valid",
        value: n.valid
      }
    ]
  };
}
function En(e) {
  const { errorBag: t, meta: n, values: r, isSubmitting: a, submitCount: i } = e;
  return {
    "Form state": [
      {
        key: "submitCount",
        value: i.value
      },
      {
        key: "isSubmitting",
        value: a.value
      },
      {
        key: "touched",
        value: n.value.touched
      },
      {
        key: "dirty",
        value: n.value.dirty
      },
      {
        key: "valid",
        value: n.value.valid
      },
      {
        key: "initialValues",
        value: n.value.initialValues
      },
      {
        key: "currentValues",
        value: r
      },
      {
        key: "errors",
        value: T(t.value).reduce((l, s) => {
          var d;
          const c = (d = t.value[s]) === null || d === void 0 ? void 0 : d[0];
          return c && (l[s] = c), l;
        }, {})
      }
    ]
  };
}
function jt(e) {
  const t = "id" in e ? e.meta.valid : e.meta.value.valid;
  return {
    bgColor: t ? W.success : W.error,
    textColor: t ? W.black : W.white
  };
}
function kn(e, t, n) {
  return he(n == null ? void 0 : n.type) ? Cn(e, t, n) : Ct(e, t, n);
}
function Ct(e, t, n) {
  const { initialValue: r, validateOnMount: a, bails: i, type: l, checkedValue: s, label: d, validateOnValueUpdate: c, uncheckedValue: O, controlled: b, keepValueOnUnmount: A, modelPropName: C, syncVModel: R, form: H } = In(f(e), n), X = b ? Ue(pe) : void 0, E = H || X;
  let D = !1;
  const { id: m, value: y, initialValue: S, meta: g, setState: p, errors: F, errorMessage: N } = bn(e, {
    modelValue: r,
    form: E
  });
  R && Nn({ value: y, prop: C, handleChange: U });
  const Q = () => {
    g.touched = !0;
  }, z = B(() => {
    let v = f(t);
    const k = f(E == null ? void 0 : E.schema);
    return k && !we(k) && (v = jn(k, f(e)) || v), we(v) || ge(v) || Array.isArray(v) ? v : Ft(v);
  });
  async function G(v) {
    var k, $;
    return E != null && E.validateSchema ? (k = (await E.validateSchema(v)).results[f(e)]) !== null && k !== void 0 ? k : { valid: !0, errors: [] } : wt(y.value, z.value, {
      name: f(d) || f(e),
      values: ($ = E == null ? void 0 : E.values) !== null && $ !== void 0 ? $ : {},
      bails: i
    });
  }
  const x = Qe(async () => (g.pending = !0, g.validated = !0, G("validated-only")), (v) => (D && (v.valid = !0, v.errors = []), p({ errors: v.errors }), g.pending = !1, v)), J = Qe(async () => G("silent"), (v) => (D && (v.valid = !0), g.valid = v.valid, v));
  function Z(v) {
    return (v == null ? void 0 : v.mode) === "silent" ? J() : x();
  }
  function U(v, k = !0) {
    const $ = Ze(v);
    y.value = $, !c && k && x();
  }
  ft(() => {
    if (a)
      return x();
    (!E || !E.validateSchema) && J();
  });
  function q(v) {
    g.touched = v;
  }
  let ne, Ve = j(y.value);
  function oe() {
    ne = K(y, (v, k) => {
      if (P(v, k) && P(v, Ve))
        return;
      (c ? x : J)(), Ve = j(v);
    }, {
      deep: !0
    });
  }
  oe();
  function ce(v) {
    var k;
    ne == null || ne();
    const $ = v && "value" in v ? v.value : S.value;
    p({
      value: j($),
      initialValue: j($),
      touched: (k = v == null ? void 0 : v.touched) !== null && k !== void 0 ? k : !1,
      errors: (v == null ? void 0 : v.errors) || []
    }), g.pending = !1, g.validated = !1, J(), me(() => {
      oe();
    });
  }
  function fe(v) {
    y.value = v;
  }
  function Oe(v) {
    p({ errors: Array.isArray(v) ? v : [v] });
  }
  const ee = {
    id: m,
    name: e,
    label: d,
    value: y,
    meta: g,
    errors: F,
    errorMessage: N,
    type: l,
    checkedValue: s,
    uncheckedValue: O,
    bails: i,
    keepValueOnUnmount: A,
    resetField: ce,
    handleReset: () => ce(),
    validate: Z,
    handleChange: U,
    handleBlur: Q,
    setState: p,
    setTouched: q,
    setErrors: Oe,
    setValue: fe
  };
  if (vt(qt, ee), Te(t) && typeof f(t) != "function" && K(t, (v, k) => {
    P(v, k) || (g.validated ? x() : J());
  }, {
    deep: !0
  }), process.env.NODE_ENV !== "production" && (ee._vm = ke(), K(() => Object.assign(Object.assign({ errors: F.value }, g), { value: y.value }), be, {
    deep: !0
  }), E || An(ee)), !E)
    return ee;
  E.register(ee), mt(() => {
    D = !0, E.unregister(ee);
  });
  const $e = B(() => {
    const v = z.value;
    return !v || ge(v) || we(v) || Array.isArray(v) ? {} : Object.keys(v).reduce((k, $) => {
      const Ie = sn(v[$]).map((de) => de.__locatorRef).reduce((de, Ae) => {
        const je = M(E.values, Ae) || E.values[Ae];
        return je !== void 0 && (de[Ae] = je), de;
      }, {});
      return Object.assign(k, Ie), k;
    }, {});
  });
  return K($e, (v, k) => {
    if (!Object.keys(v).length)
      return;
    !P(v, k) && (g.validated ? x() : J());
  }), ee;
}
function In(e, t) {
  const n = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: e,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    modelPropName: "modelValue",
    syncVModel: !0,
    controlled: !0
  });
  if (!t)
    return n();
  const r = "valueProp" in t ? t.valueProp : t.checkedValue, a = "standalone" in t ? !t.standalone : t.controlled;
  return Object.assign(Object.assign(Object.assign({}, n()), t || {}), { controlled: a ?? !0, checkedValue: r });
}
function jn(e, t) {
  if (e)
    return e[t];
}
function Cn(e, t, n) {
  const r = n != null && n.standalone ? void 0 : Ue(pe), a = n == null ? void 0 : n.checkedValue, i = n == null ? void 0 : n.uncheckedValue;
  function l(s) {
    const d = s.handleChange, c = B(() => {
      const b = f(s.value), A = f(a);
      return Array.isArray(b) ? b.findIndex((C) => P(C, A)) >= 0 : P(A, b);
    });
    function O(b, A = !0) {
      var C;
      if (c.value === ((C = b == null ? void 0 : b.target) === null || C === void 0 ? void 0 : C.checked)) {
        A && s.validate();
        return;
      }
      let R = Ze(b);
      r || (R = Ke(f(s.value), f(a), f(i))), d(R, A);
    }
    return Object.assign(Object.assign({}, s), {
      checked: c,
      checkedValue: a,
      uncheckedValue: i,
      handleChange: O
    });
  }
  return l(Ct(e, t, n));
}
function Nn({ prop: e, value: t, handleChange: n }) {
  const r = ke();
  if (!r) {
    process.env.NODE_ENV !== "production" && console.warn("Failed to setup model events because `useField` was not called in setup.");
    return;
  }
  const a = e || "modelValue", i = `update:${a}`;
  a in r.props && (K(t, (l) => {
    P(l, ct(r, a)) || r.emit(i, l);
  }), K(() => ct(r, a), (l) => {
    if (l === Pe && t.value === void 0)
      return;
    const s = l === Pe ? void 0 : l;
    P(s, rn(t.value, r.props.modelModifiers)) || n(s);
  }));
}
function ct(e, t) {
  return e.props[t];
}
const Mn = Re({
  name: "Field",
  inheritAttrs: !1,
  props: {
    as: {
      type: [String, Object],
      default: void 0
    },
    name: {
      type: String,
      required: !0
    },
    rules: {
      type: [Object, String, Function],
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    validateOnBlur: {
      type: Boolean,
      default: void 0
    },
    validateOnChange: {
      type: Boolean,
      default: void 0
    },
    validateOnInput: {
      type: Boolean,
      default: void 0
    },
    validateOnModelUpdate: {
      type: Boolean,
      default: void 0
    },
    bails: {
      type: Boolean,
      default: () => et().bails
    },
    label: {
      type: String,
      default: void 0
    },
    uncheckedValue: {
      type: null,
      default: void 0
    },
    modelValue: {
      type: null,
      default: Pe
    },
    modelModifiers: {
      type: null,
      default: () => ({})
    },
    "onUpdate:modelValue": {
      type: null,
      default: void 0
    },
    standalone: {
      type: Boolean,
      default: !1
    },
    keepValue: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e, t) {
    const n = ue(e, "rules"), r = ue(e, "name"), a = ue(e, "label"), i = ue(e, "uncheckedValue"), l = ue(e, "keepValue"), { errors: s, value: d, errorMessage: c, validate: O, handleChange: b, handleBlur: A, setTouched: C, resetField: R, handleReset: H, meta: X, checked: E, setErrors: D } = kn(r, n, {
      validateOnMount: e.validateOnMount,
      bails: e.bails,
      standalone: e.standalone,
      type: t.attrs.type,
      initialValue: Bn(e, t),
      // Only for checkboxes and radio buttons
      checkedValue: t.attrs.value,
      uncheckedValue: i,
      label: a,
      validateOnValueUpdate: !1,
      keepValueOnUnmount: l
    }), m = function(N, Q = !0) {
      b(N, Q), t.emit("update:modelValue", d.value);
    }, y = (F) => {
      he(t.attrs.type) || (d.value = Ze(F));
    }, S = function(N) {
      y(N), t.emit("update:modelValue", d.value);
    }, g = B(() => {
      const { validateOnInput: F, validateOnChange: N, validateOnBlur: Q, validateOnModelUpdate: z } = Tn(e), G = [A, t.attrs.onBlur, Q ? O : void 0].filter(Boolean), x = [(q) => m(q, F), t.attrs.onInput].filter(Boolean), J = [(q) => m(q, N), t.attrs.onChange].filter(Boolean), Z = {
        name: e.name,
        onBlur: G,
        onInput: x,
        onChange: J
      };
      Z["onUpdate:modelValue"] = (q) => m(q, z), he(t.attrs.type) && E && (Z.checked = E.value);
      const U = dt(e, t);
      return en(U, t.attrs) && (Z.value = d.value), Z;
    });
    function p() {
      return {
        field: g.value,
        value: d.value,
        meta: X,
        errors: s.value,
        errorMessage: c.value,
        validate: O,
        resetField: R,
        handleChange: m,
        handleInput: S,
        handleReset: H,
        handleBlur: A,
        setTouched: C,
        setErrors: D
      };
    }
    return t.expose({
      setErrors: D,
      setTouched: C,
      reset: R,
      validate: O,
      handleChange: b
    }), () => {
      const F = qe(dt(e, t)), N = Le(F, t, p);
      return F ? Be(F, Object.assign(Object.assign({}, t.attrs), g.value), N) : N;
    };
  }
});
function dt(e, t) {
  let n = e.as || "";
  return !e.as && !t.slots.default && (n = "input"), n;
}
function Tn(e) {
  var t, n, r, a;
  const { validateOnInput: i, validateOnChange: l, validateOnBlur: s, validateOnModelUpdate: d } = et();
  return {
    validateOnInput: (t = e.validateOnInput) !== null && t !== void 0 ? t : i,
    validateOnChange: (n = e.validateOnChange) !== null && n !== void 0 ? n : l,
    validateOnBlur: (r = e.validateOnBlur) !== null && r !== void 0 ? r : s,
    validateOnModelUpdate: (a = e.validateOnModelUpdate) !== null && a !== void 0 ? a : d
  };
}
function Bn(e, t) {
  return he(t.attrs.type) ? it(e, "modelValue") ? e.modelValue : void 0 : it(e, "modelValue") ? e.modelValue : t.attrs.value;
}
const Gn = Mn;
let Pn = 0;
function Rn(e) {
  var t;
  const n = Pn++, r = /* @__PURE__ */ new Set();
  let a = !1;
  const i = Y({}), l = Y(!1), s = Y(0), d = [], c = Je(j(f(e == null ? void 0 : e.initialValues) || {})), { errorBag: O, setErrorBag: b, setFieldErrorBag: A } = Ln(e == null ? void 0 : e.initialErrors), C = B(() => T(O.value).reduce((u, o) => {
    const h = O.value[o];
    return h && h.length && (u[o] = h[0]), u;
  }, {}));
  function R(u) {
    const o = i.value[u];
    return Array.isArray(o) ? o[0] : o;
  }
  function H(u) {
    return !!i.value[u];
  }
  const X = B(() => T(i.value).reduce((u, o) => {
    const h = R(o);
    return h && (u[o] = f(h.label || h.name) || ""), u;
  }, {})), E = B(() => T(i.value).reduce((u, o) => {
    var h;
    const V = R(o);
    return V && (u[o] = (h = V.bails) !== null && h !== void 0 ? h : !0), u;
  }, {})), D = Object.assign({}, (e == null ? void 0 : e.initialErrors) || {}), m = (t = e == null ? void 0 : e.keepValuesOnUnmount) !== null && t !== void 0 ? t : !1, { initialValues: y, originalInitialValues: S, setInitialValues: g } = Un(i, c, e == null ? void 0 : e.initialValues), p = Dn(i, c, S, C), F = B(() => [...r, ...T(i.value)].reduce((u, o) => {
    const h = M(c, o);
    return ae(u, o, h), u;
  }, {})), N = e == null ? void 0 : e.validationSchema, Q = ut(rt, 5), z = ut(rt, 5), G = Qe(async (u) => await u === "silent" ? Q() : z(), (u, [o]) => {
    const h = U.fieldsByPath.value || {}, V = T(U.errorBag.value);
    return [
      .../* @__PURE__ */ new Set([...T(u.results), ...T(h), ...V])
    ].reduce((w, _) => {
      const L = h[_], re = (u.results[_] || { errors: [] }).errors, te = {
        errors: re,
        valid: !re.length
      };
      if (w.results[_] = te, te.valid || (w.errors[_] = te.errors[0]), !L)
        return oe(_, re), w;
      if (ne(L, (Se) => Se.meta.valid = te.valid), o === "silent")
        return w;
      const Bt = Array.isArray(L) ? L.some((Se) => Se.meta.validated) : L.meta.validated;
      return o === "validated-only" && !Bt || ne(L, (Se) => Se.setState({ errors: te.errors })), w;
    }, { valid: u.valid, results: {}, errors: {} });
  });
  function x(u) {
    return function(h, V) {
      return function(w) {
        return w instanceof Event && (w.preventDefault(), w.stopPropagation()), k(T(i.value).reduce((_, L) => (_[L] = !0, _), {})), l.value = !0, s.value++, Ce().then((_) => {
          const L = j(c);
          if (_.valid && typeof h == "function") {
            const re = j(F.value);
            return h(u ? re : L, {
              evt: w,
              controlledValues: re,
              setErrors: ce,
              setFieldError: oe,
              setTouched: k,
              setFieldTouched: v,
              setValues: Oe,
              setFieldValue: fe,
              resetForm: $
            });
          }
          !_.valid && typeof V == "function" && V({
            values: L,
            evt: w,
            errors: _.errors,
            results: _.results
          });
        }).then((_) => (l.value = !1, _), (_) => {
          throw l.value = !1, _;
        });
      };
    };
  }
  const Z = x(!1);
  Z.withControlled = x(!0);
  const U = {
    formId: n,
    fieldsByPath: i,
    values: c,
    controlledValues: F,
    errorBag: O,
    errors: C,
    schema: N,
    submitCount: s,
    meta: p,
    isSubmitting: l,
    fieldArrays: d,
    keepValuesOnUnmount: m,
    validateSchema: f(N) ? G : void 0,
    validate: Ce,
    register: Ae,
    unregister: je,
    setFieldErrorBag: A,
    validateField: ze,
    setFieldValue: fe,
    setValues: Oe,
    setErrors: ce,
    setFieldError: oe,
    setFieldTouched: v,
    setTouched: k,
    resetForm: $,
    handleSubmit: Z,
    stageInitialValue: Mt,
    unsetInitialValue: Nt,
    setFieldInitialValue: nt,
    useFieldModel: $e
  };
  function q(u) {
    return Array.isArray(u);
  }
  function ne(u, o) {
    return Array.isArray(u) ? u.forEach(o) : o(u);
  }
  function Ve(u) {
    Object.values(i.value).forEach((o) => {
      o && ne(o, u);
    });
  }
  function oe(u, o) {
    A(u, o);
  }
  function ce(u) {
    b(u);
  }
  function fe(u, o, { force: h } = { force: !1 }) {
    var V;
    const I = i.value[u], w = j(o);
    if (!I) {
      ae(c, u, w);
      return;
    }
    if (q(I) && ((V = I[0]) === null || V === void 0 ? void 0 : V.type) === "checkbox" && !Array.isArray(o)) {
      const L = j(Ke(M(c, u) || [], o, void 0));
      ae(c, u, L);
      return;
    }
    let _ = w;
    !q(I) && I.type === "checkbox" && !h && !a && (_ = j(Ke(M(c, u), o, f(I.uncheckedValue)))), ae(c, u, _);
  }
  function Oe(u) {
    T(c).forEach((o) => {
      delete c[o];
    }), T(u).forEach((o) => {
      fe(o, u[o]);
    }), d.forEach((o) => o && o.reset());
  }
  function ee(u) {
    const { value: o } = Et(u, void 0, U);
    return K(o, () => {
      H(f(u)) || Ce({ mode: "validated-only" });
    }, {
      deep: !0
    }), r.add(f(u)), o;
  }
  function $e(u) {
    return Array.isArray(u) ? u.map(ee) : ee(u);
  }
  function v(u, o) {
    const h = i.value[u];
    h && ne(h, (V) => V.setTouched(o));
  }
  function k(u) {
    T(u).forEach((o) => {
      v(o, !!u[o]);
    });
  }
  function $(u) {
    a = !0, Ve((h) => h.resetField());
    const o = u != null && u.values ? u.values : S.value;
    g(o), Oe(o), u != null && u.touched && k(u.touched), ce((u == null ? void 0 : u.errors) || {}), s.value = (u == null ? void 0 : u.submitCount) || 0, me(() => {
      a = !1;
    });
  }
  function Ie(u, o) {
    const h = Rt(u), V = o;
    if (!i.value[V]) {
      i.value[V] = h;
      return;
    }
    const I = i.value[V];
    I && !Array.isArray(I) && (i.value[V] = [I]), i.value[V] = [...i.value[V], h];
  }
  function de(u, o) {
    const h = o, V = i.value[h];
    if (V) {
      if (!q(V) && u.id === V.id) {
        delete i.value[h];
        return;
      }
      if (q(V)) {
        const I = V.findIndex((w) => w.id === u.id);
        if (I === -1)
          return;
        V.splice(I, 1), V.length || delete i.value[h];
      }
    }
  }
  function Ae(u) {
    const o = f(u.name);
    Ie(u, o), Te(u.name) && K(u.name, async (V, I) => {
      await me(), de(u, I), Ie(u, V), (C.value[I] || C.value[V]) && (oe(I, void 0), ze(V)), await me(), H(I) || Ne(c, I);
    });
    const h = f(u.errorMessage);
    h && (D == null ? void 0 : D[o]) !== h && ze(o), delete D[o];
  }
  function je(u) {
    const o = f(u.name), h = i.value[o], V = !!h && q(h);
    de(u, o), me(() => {
      var I;
      const w = (I = f(u.keepValueOnUnmount)) !== null && I !== void 0 ? I : f(m), _ = M(c, o);
      if (V && (h === i.value[o] || !i.value[o]) && !w)
        if (Array.isArray(_)) {
          const re = _.findIndex((te) => P(te, f(u.checkedValue)));
          if (re > -1) {
            const te = [..._];
            te.splice(re, 1), fe(o, te, { force: !0 });
          }
        } else
          _ === f(u.checkedValue) && Ne(c, o);
      if (!H(o)) {
        if (oe(o, void 0), w || V && Array.isArray(_) && !Vt(_))
          return;
        Ne(c, o);
      }
    });
  }
  async function Ce(u) {
    const o = (u == null ? void 0 : u.mode) || "force";
    if (o === "force" && Ve((w) => w.meta.validated = !0), U.validateSchema)
      return U.validateSchema(o);
    const h = await Promise.all(Object.values(i.value).map((w) => {
      const _ = Array.isArray(w) ? w[0] : w;
      return _ ? _.validate(u).then((L) => ({
        key: f(_.name),
        valid: L.valid,
        errors: L.errors
      })) : Promise.resolve({ key: "", valid: !0, errors: [] });
    })), V = {}, I = {};
    for (const w of h)
      V[w.key] = {
        valid: w.valid,
        errors: w.errors
      }, w.errors.length && (I[w.key] = w.errors[0]);
    return {
      valid: h.every((w) => w.valid),
      results: V,
      errors: I
    };
  }
  async function ze(u) {
    const o = i.value[u];
    return o ? Array.isArray(o) ? o.map((h) => h.validate())[0] : o.validate() : (yt(`field with name ${u} was not found`), Promise.resolve({ errors: [], valid: !0 }));
  }
  function Nt(u) {
    Ne(y.value, u);
  }
  function Mt(u, o, h = !1) {
    ae(c, u, o), nt(u, o), h && !(e != null && e.initialValues) && ae(S.value, u, j(o));
  }
  function nt(u, o) {
    ae(y.value, u, j(o));
  }
  async function rt() {
    const u = f(N);
    return u ? we(u) ? await gn(u, c) : await hn(u, c, {
      names: X.value,
      bailsMap: E.value
    }) : { valid: !0, results: {}, errors: {} };
  }
  const Tt = Z((u, { evt: o }) => {
    At(o) && o.target.submit();
  });
  return ft(() => {
    if (e != null && e.initialErrors && ce(e.initialErrors), e != null && e.initialTouched && k(e.initialTouched), e != null && e.validateOnMount) {
      Ce();
      return;
    }
    U.validateSchema && U.validateSchema("silent");
  }), Te(N) && K(N, () => {
    var u;
    (u = U.validateSchema) === null || u === void 0 || u.call(U, "validated-only");
  }), vt(pe, U), process.env.NODE_ENV !== "production" && (On(U), K(() => Object.assign(Object.assign({ errors: O.value }, p.value), { values: c, isSubmitting: l.value, submitCount: s.value }), be, {
    deep: !0
  })), Object.assign(Object.assign({}, U), { handleReset: () => $(), submitForm: Tt });
}
function Dn(e, t, n, r) {
  const a = {
    touched: "some",
    pending: "some",
    valid: "every"
  }, i = B(() => !P(t, f(n)));
  function l() {
    const d = Object.values(e.value).flat(1).filter(Boolean);
    return T(a).reduce((c, O) => {
      const b = a[O];
      return c[O] = d[b]((A) => A.meta[O]), c;
    }, {});
  }
  const s = Je(l());
  return Pt(() => {
    const d = l();
    s.touched = d.touched, s.valid = d.valid, s.pending = d.pending;
  }), B(() => Object.assign(Object.assign({ initialValues: f(n) }, s), { valid: s.valid && !T(r.value).length, dirty: i.value }));
}
function Un(e, t, n) {
  const r = Y(j(f(n)) || {}), a = Y(j(f(n)) || {});
  function i(l, s = !1) {
    r.value = j(l), a.value = j(l), s && T(e.value).forEach((d) => {
      const c = e.value[d], O = Array.isArray(c) ? c.some((A) => A.meta.touched) : c == null ? void 0 : c.meta.touched;
      if (!c || O)
        return;
      const b = M(r.value, d);
      ae(t, d, j(b));
    });
  }
  return Te(n) && K(n, (l) => {
    i(l, !0);
  }, {
    deep: !0
  }), {
    initialValues: r,
    originalInitialValues: a,
    setInitialValues: i
  };
}
function Ln(e) {
  const t = Y({});
  function n(i) {
    return Array.isArray(i) ? i : i ? [i] : [];
  }
  function r(i, l) {
    if (!l) {
      delete t.value[i];
      return;
    }
    t.value[i] = n(l);
  }
  function a(i) {
    t.value = T(i).reduce((l, s) => {
      const d = i[s];
      return d && (l[s] = n(d)), l;
    }, {});
  }
  return e && a(e), {
    errorBag: t,
    setErrorBag: a,
    setFieldErrorBag: r
  };
}
Re({
  name: "Form",
  inheritAttrs: !1,
  props: {
    as: {
      type: String,
      default: "form"
    },
    validationSchema: {
      type: Object,
      default: void 0
    },
    initialValues: {
      type: Object,
      default: void 0
    },
    initialErrors: {
      type: Object,
      default: void 0
    },
    initialTouched: {
      type: Object,
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    onSubmit: {
      type: Function,
      default: void 0
    },
    onInvalidSubmit: {
      type: Function,
      default: void 0
    },
    keepValues: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    const n = ue(e, "initialValues"), r = ue(e, "validationSchema"), a = ue(e, "keepValues"), { errors: i, values: l, meta: s, isSubmitting: d, submitCount: c, controlledValues: O, validate: b, validateField: A, handleReset: C, resetForm: R, handleSubmit: H, setErrors: X, setFieldError: E, setFieldValue: D, setValues: m, setFieldTouched: y, setTouched: S } = Rn({
      validationSchema: r.value ? r : void 0,
      initialValues: n,
      initialErrors: e.initialErrors,
      initialTouched: e.initialTouched,
      validateOnMount: e.validateOnMount,
      keepValuesOnUnmount: a
    }), g = H((z, { evt: G }) => {
      At(G) && G.target.submit();
    }, e.onInvalidSubmit), p = e.onSubmit ? H(e.onSubmit, e.onInvalidSubmit) : g;
    function F(z) {
      Ye(z) && z.preventDefault(), C(), typeof t.attrs.onReset == "function" && t.attrs.onReset();
    }
    function N(z, G) {
      return H(typeof z == "function" && !G ? z : G, e.onInvalidSubmit)(z);
    }
    function Q() {
      return {
        meta: s.value,
        errors: i.value,
        values: l,
        isSubmitting: d.value,
        submitCount: c.value,
        controlledValues: O.value,
        validate: b,
        validateField: A,
        handleSubmit: N,
        handleReset: C,
        submitForm: g,
        setErrors: X,
        setFieldError: E,
        setFieldValue: D,
        setValues: m,
        setFieldTouched: y,
        setTouched: S,
        resetForm: R
      };
    }
    return t.expose({
      setFieldError: E,
      setErrors: X,
      setFieldValue: D,
      setValues: m,
      setFieldTouched: y,
      setTouched: S,
      resetForm: R,
      validate: b,
      validateField: A
    }), function() {
      const G = e.as === "form" ? e.as : qe(e.as), x = Le(G, t, Q);
      if (!e.as)
        return x;
      const J = e.as === "form" ? {
        // Disables native validation as vee-validate will handle it.
        novalidate: !0
      } : {};
      return Be(G, Object.assign(Object.assign(Object.assign({}, J), t.attrs), { onSubmit: p, onReset: F }), x);
    };
  }
});
function $n(e) {
  const t = Ue(pe, void 0), n = Y([]), r = () => {
  }, a = {
    fields: n,
    remove: r,
    push: r,
    swap: r,
    insert: r,
    update: r,
    replace: r,
    prepend: r,
    move: r
  };
  if (!t)
    return Me("FieldArray requires being a child of `<Form/>` or `useForm` being called before it. Array fields may not work correctly"), a;
  if (!f(e))
    return Me("FieldArray requires a field path to be provided, did you forget to pass the `name` prop?"), a;
  const i = t.fieldArrays.find((m) => f(m.path) === f(e));
  if (i)
    return i;
  let l = 0;
  function s() {
    const m = M(t == null ? void 0 : t.values, f(e), []) || [];
    n.value = m.map(c), d();
  }
  s();
  function d() {
    const m = n.value.length;
    for (let y = 0; y < m; y++) {
      const S = n.value[y];
      S.isFirst = y === 0, S.isLast = y === m - 1;
    }
  }
  function c(m) {
    const y = l++;
    return {
      key: y,
      value: an({
        get() {
          const g = M(t == null ? void 0 : t.values, f(e), []) || [], p = n.value.findIndex((F) => F.key === y);
          return p === -1 ? m : g[p];
        },
        set(g) {
          const p = n.value.findIndex((F) => F.key === y);
          if (p === -1) {
            Me("Attempting to update a non-existent array item");
            return;
          }
          H(p, g);
        }
      }),
      isFirst: !1,
      isLast: !1
    };
  }
  function O(m) {
    const y = f(e), S = M(t == null ? void 0 : t.values, y);
    if (!S || !Array.isArray(S))
      return;
    const g = [...S];
    g.splice(m, 1), t == null || t.unsetInitialValue(y + `[${m}]`), t == null || t.setFieldValue(y, g), n.value.splice(m, 1), d();
  }
  function b(m) {
    const y = f(e), S = M(t == null ? void 0 : t.values, y), g = Fe(S) ? [] : S;
    if (!Array.isArray(g))
      return;
    const p = [...g];
    p.push(m), t == null || t.stageInitialValue(y + `[${p.length - 1}]`, m), t == null || t.setFieldValue(y, p), n.value.push(c(m)), d();
  }
  function A(m, y) {
    const S = f(e), g = M(t == null ? void 0 : t.values, S);
    if (!Array.isArray(g) || !(m in g) || !(y in g))
      return;
    const p = [...g], F = [...n.value], N = p[m];
    p[m] = p[y], p[y] = N;
    const Q = F[m];
    F[m] = F[y], F[y] = Q, t == null || t.setFieldValue(S, p), n.value = F, d();
  }
  function C(m, y) {
    const S = f(e), g = M(t == null ? void 0 : t.values, S);
    if (!Array.isArray(g) || g.length < m)
      return;
    const p = [...g], F = [...n.value];
    p.splice(m, 0, y), F.splice(m, 0, c(y)), t == null || t.setFieldValue(S, p), n.value = F, d();
  }
  function R(m) {
    const y = f(e);
    t == null || t.setFieldValue(y, m), s();
  }
  function H(m, y) {
    const S = f(e), g = M(t == null ? void 0 : t.values, S);
    !Array.isArray(g) || g.length - 1 < m || (t == null || t.setFieldValue(`${S}[${m}]`, y), t == null || t.validate({ mode: "validated-only" }));
  }
  function X(m) {
    const y = f(e), S = M(t == null ? void 0 : t.values, y), g = Fe(S) ? [] : S;
    if (!Array.isArray(g))
      return;
    const p = [m, ...g];
    t == null || t.stageInitialValue(y + `[${p.length - 1}]`, m), t == null || t.setFieldValue(y, p), n.value.unshift(c(m)), d();
  }
  function E(m, y) {
    const S = f(e), g = M(t == null ? void 0 : t.values, S), p = Fe(g) ? [] : [...g];
    if (!Array.isArray(g) || !(m in g) || !(y in g))
      return;
    const F = [...n.value], N = F[m];
    F.splice(m, 1), F.splice(y, 0, N);
    const Q = p[m];
    p.splice(m, 1), p.splice(y, 0, Q), t == null || t.setFieldValue(S, p), n.value = F, d();
  }
  const D = {
    fields: n,
    remove: O,
    push: b,
    swap: A,
    insert: C,
    update: H,
    replace: R,
    prepend: X,
    move: E
  };
  return t.fieldArrays.push(Object.assign({ path: e, reset: s }, D)), mt(() => {
    const m = t.fieldArrays.findIndex((y) => f(y.path) === f(e));
    m >= 0 && t.fieldArrays.splice(m, 1);
  }), D;
}
Re({
  name: "FieldArray",
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  setup(e, t) {
    const { push: n, remove: r, swap: a, insert: i, replace: l, update: s, prepend: d, move: c, fields: O } = $n(ue(e, "name"));
    function b() {
      return {
        fields: O.value,
        push: n,
        remove: r,
        swap: a,
        insert: i,
        update: s,
        replace: l,
        prepend: d,
        move: c
      };
    }
    return t.expose({
      push: n,
      remove: r,
      swap: a,
      insert: i,
      update: s,
      replace: l,
      prepend: d,
      move: c
    }), () => Le(void 0, t, b);
  }
});
Re({
  name: "ErrorMessage",
  props: {
    as: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      required: !0
    }
  },
  setup(e, t) {
    const n = gt(pe, void 0), r = B(() => n == null ? void 0 : n.errors.value[e.name]);
    function a() {
      return {
        message: r.value
      };
    }
    return () => {
      if (!r.value)
        return;
      const i = e.as ? qe(e.as) : e.as, l = Le(i, t, a), s = Object.assign({ role: "alert" }, t.attrs);
      return !i && (Array.isArray(l) || !l) && (l != null && l.length) ? l : (Array.isArray(l) || !l) && !(l != null && l.length) ? Be(i || "span", s, r.value) : Be(i, s, l);
    };
  }
});
function xn() {
  const e = Ue(pe);
  return e || Me("No vee-validate <Form /> or `useForm` was detected in the component tree"), function() {
    return e ? e.validate() : Promise.resolve({ results: {}, errors: {}, valid: !0 });
  };
}
export {
  Gn as F,
  kn as a,
  Rn as b,
  xn as u
};
